import Vue from 'vue'
import Router from 'vue-router'

import index from '@/page/index.vue'

import articlework from '@/page/articlework.vue'
import articlepro from '@/page/articlepro.vue'
import articlecrm from '@/page/articlecrm.vue'
import articleguest from '@/page/articleguest.vue'
import articledesign from '@/page/articledesign.vue'
import articlecargo from '@/page/articlecargo.vue'
import articlehub from '@/page/articlehub.vue'
import articleAi from '@/page/articleAi.vue'
import banben from '@/page/banben.vue'
import use from '@/page/use.vue'
import privacy from '@/page/privacy.vue'
import safe from '@/page/safe.vue'
import cookie from '@/page/cookie.vue'
import activity from '@/page/activity.vue'

//  产品product  充值recharge  公司company  联系about
Vue.use(Router)

let service = new Router({
  mode: 'history',
  // base:'./static/',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/articlework',
      name: 'articlework',
      component: articlework
    },
    {
      path: '/articlepro',
      name: 'articlepro',
      component: articlepro
    },
    {
      path: '/articlecrm',
      name: 'articlecrm',
      component: articlecrm
    },
    {
      path: '/articleguest',
      name: 'articleguest',
      component: articleguest
    },
    {
      path: '/articledesign',
      name: 'articledesign',
      component: articledesign
    },
    {
      path: '/articlecargo',
      name: 'articlecargo',
      component: articlecargo
    },
    {
      path: '/articlehub',
      name: 'articlehub',
      component: articlehub
    },
    {
      path: '/articleAi',
      name: 'articleAi',
      component: articleAi
    },
    {
      path: '/banben',
      name: 'banben',
      component: banben
    },
    {
      path: '/use',
      name: 'use',
      component: use
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy
    },
    {
      path: '/safe',
      name: 'safe',
      component: safe
    },
    {
      path: '/cookie',
      name: 'cookie',
      component: cookie
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
  ],
})

//使用钩子函数对路由进行权限跳转
// service.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');
//   const real = localStorage.getItem('real');
//   if(to.meta.auth){
//     if(!token){
//       next('/login')
//     }else{
//       next()
//       // 权限
//       if(to.meta.real){
//         if(real != 2){
//         	next('/MyEdit')
//         }else{
//           next()
//         }
//       }
//     }
//   }else{
//     next()
//   }

// });

export default service;



// WEBPACK FOOTER //
// ./src/router/index.js